import { postMessage } from "./extensionMessenger";

export const getExtensionVersion = callback => {
  postMessage({
    type: "getExtensionVersion",
    callback
  });
};
